import React from "react";
import useUser from "./useUser";

let timeout: NodeJS.Timeout | null = null;

const usePushNotification = () => {
  const user = useUser();

  const [permission, setPermission] = React.useState<NotificationPermission>(
    typeof window !== "undefined" && window.Notification
      ? window.Notification.permission
      : "denied",
  );
  const requestPermission = () => {
    if (typeof window !== "undefined" && window.Notification) {
      window.Notification.requestPermission().then((permission) => {
        setPermission(permission);
      });
      // .catch((err) => {});
    }
  };

  const sendNotification = ({
    body,
    title,
    onClick,
  }: {
    title: string;
    body: string;
    image?: string;
    onClick?: () => void;
  }) => {
    if (
      typeof window !== "undefined" &&
      permission === "granted" &&
      !user.user.notifications?.mute
    ) {
      const notification = new window.Notification(title, {
        body,
        icon: "/static/images/logo.png",
        badge: "/static/images/logo.png",
      });
      notification.onclick = () => onClick && onClick();
      timeout = setTimeout(() => notification.close(), 10 * 1000);

      notification.addEventListener("close", () => {
        if (timeout) {
          clearTimeout(timeout);
        }
      });
    }
  };

  return { requestPermission, permission, sendNotification };
};

export default usePushNotification;
